import React from "react";

function CheckBoxInput({
  label,
  ariaLabel = "",
  id,
  name,
  disabled = false,
  required = false,
  handleClick,
  labelClick,
  errorMessage,
  checked = false,
  value,
  handleBlur,
  style,
  title,
  "aria-label": ariaLabelProp,
  "aria-required": ariaRequiredProp,
}) {
  const isRequired = ariaRequiredProp !== undefined ? ariaRequiredProp : required;
  const ariaLabelText =
    ariaLabelProp ||
    ariaLabel ||
    (typeof label === "string" && label.trim() ? label.trim() : "") ||
    (typeof name === "string" && name.trim() ? name.trim() : "") ||
    "Checkbox";

  return (
    <div
      className={`form-check mt-2 ${disabled ? "cursor-not-allowed" : "cursor-pointer"
        }`}
    >
      {label && (
        <label
          className="form-check-label fs-5 form-label-custom-visible"
          htmlFor={id || name}
          style={{ color: "#111827", fontWeight: "400" }}
          onClick={labelClick}
        >
          {label}{" "}
          {isRequired && (
            <span className="text-danger">
              *
            </span>
          )}
        </label>
      )}
      <input
        // className="form-check-input cursor-pointer"
        className={`form-check-input cursor-pointer ${disabled && checked === false ? "bg-gray-500 cursor-not-allowed" : ""
          }`}
        type="checkbox"
        value={value}
        id={id || name}
        style={style}
        disabled={disabled}
        name={name}
        onChange={handleClick}
        checked={checked}
        onBlur={handleBlur}
        aria-label={ariaLabelText}
        aria-required={isRequired}
      />
      {title && (
        <span
          style={{
            marginLeft: "10px",
            position: "relative",
            top: "2px",
          }}
        >
          <i
            title={title}
            className="fs-4 fa fa-info-circle"
            aria-hidden="true"
          ></i>
        </span>
      )}
      {errorMessage &&
        errorMessage[name] &&
        Object?.keys(errorMessage).length > 0 && (
          <div className="text-danger fw-700 fs-6 mt-1">
            {errorMessage && errorMessage[name] && errorMessage[name]}
          </div>
        )}
    </div>
  );
}

export default CheckBoxInput;
